module.exports = __webpack_public_path__ + "img/logo-img2.8dc8c139.png";